import { Component, Input, OnInit} from '@angular/core';
import * as Chart from 'chart.js';

@Component({
  selector: 'vehicle-speed-chart',
  templateUrl: './vehicle-speed-chart.component.html',
  styleUrls: ['./vehicle-speed-chart.component.css']
})
export class VehicleSpeedChartComponent implements OnInit {

  public lineChartType: string = 'line';

  @Input()
  public chartData: any[] = [];

  @Input()
  public chartLabels: any[] = [];

  @Input()
  public chartUnitType: any;

  public chartLabelsFormated: any = []

  public ctx: HTMLCanvasElement;
  public chart: Chart;

  constructor(){}

  ngOnInit(): void {

  }
  
  ngOnChanges() {
    this.ctx = <HTMLCanvasElement>document.getElementById('chart');
    this.ctx.getContext('2d');
    
    // this.chartLabels.forEach((item) => {
    //   this.chartLabelsFormated.push(`${item.toString().substr(0, 19)}`);
    // })

    if (this.chart != undefined){
      this.chart.destroy();
    }

    this.chart = new Chart(this.ctx, {
      type: 'line',

      data: {
        labels: this.chartLabels,
        datasets: [{
          label: 'Velocidade do Veículo',
          backgroundColor: 'rgb(54,162,235,0.0)',
          borderWidth: 0,
          borderColor: 'rgb(54, 162, 235, 0.0)',
          pointBackgroundColor: 'rgba(54,162,235, 0.6)',
          pointRadius: 5,
          data: this.chartData[0]
        },
        {
          label: 'Velocidade Média',
          backgroundColor: 'rgb(77,830,96,0.0)',
          borderWidth: 1.8,
          borderColor: 'rgb(255, 204, 0, 0.6)',
          pointRadius: 0,
          data: this.chartData[1]
        },
        {
          label: 'Limite de Velocidade',
          backgroundColor: 'rgb(148,159,177,0)',
          borderWidth: 1.6,
          borderColor: 'rgb(255, 99, 132, 0.6)',
          pointRadius: 0,
          data: this.chartData[2]
        }]
      },

      options: {
        responsive: true,
        title: {
          display: false,
          text: 'Velocidade dos veículos',
          fontColor: 'black',
          fontSize: 22
        },
        scales: {
          xAxes: [{
            type: 'time',
            time: {
              tooltipFormat: 'MM/DD/YYYY HH:mm',
              unit: this.chartUnitType,
              displayFormats: {
                hour:'HH:mm',
                day: 'MM/DD/YY'
              }
            },
              ticks: {
              reverse: false,
              fontColor: 'black',
            },
            gridLines: {
              color: '#ffffff'
            }
          }],
          yAxes: [{
            ticks: {
              fontColor: 'black',
              min: 0,
              beginAtZero: false,
              precision: 0
            },
            gridLines: {
              color: '#ffffff'
            },
            scaleLabel: {
              display: false,
              labelString: 'Scale Label',
              fontColor: 'black',
            }
          }]
        },
        legend: {
          display: false,
          labels: {
            fontColor: 'black',
            usePointStyle: true
          }
        },
      }
    });
  }
}
